import React from 'react';
import { FileSpreadsheet, Loader2, Trash2, Upload as UploadIcon } from 'lucide-react';

export function UploadCard({ title, subtitle, uploading, onChoose, onClear, testIdPrefix, accent }) {
  return (
    <div className="rounded-2xl bg-white/75 backdrop-blur border border-white/50 shadow-[0_8px_30px_rgba(15,23,42,0.04)] p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-10 h-10 rounded-xl ${accent === 'sky' ? 'bg-gradient-to-br from-sky-500 to-indigo-500' : 'bg-gradient-to-br from-violet-500 to-fuchsia-500'} text-white flex items-center justify-center shadow-md`}>
          <FileSpreadsheet size={18} />
        </div>
        <div className="min-w-0">
          <h3 className="text-[14px] font-semibold text-slate-900">{title}</h3>
          <p className="text-[11.5px] text-slate-500 line-clamp-2">{subtitle}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <input type="file" accept=".xlsx,.xls" onChange={(e) => onChoose(e.target.files?.[0])} id={`${testIdPrefix}-upload`} data-testid={`${testIdPrefix}-file-input`} className="hidden" />
        <label
          htmlFor={`${testIdPrefix}-upload`}
          className="px-3.5 py-2 rounded-xl text-white text-[13px] font-medium shadow-sm hover:shadow-md cursor-pointer inline-flex items-center gap-2"
          style={{ background: accent === 'sky' ? 'linear-gradient(135deg, #0EA5E9 0%, #6366F1 100%)' : 'linear-gradient(135deg, #8B5CF6 0%, #DB2777 100%)' }}
        >
          {uploading ? <Loader2 size={14} className="animate-spin" /> : <UploadIcon size={14} />}
          {uploading ? 'Uploading…' : `Upload ${title}`}
        </label>
        <button onClick={onClear} data-testid={`${testIdPrefix}-clear-btn`} className="px-3 py-2 rounded-xl bg-white border border-slate-200 text-slate-600 text-[12.5px] hover:bg-slate-50 inline-flex items-center gap-1.5">
          <Trash2 size={13} /> Clear
        </button>
      </div>
    </div>
  );
}
